module.exports = __webpack_public_path__ + "img/svg/background-no-home.eb7e9e40a950053ee0cafe0efc0c0bc8.svg";